<ng-container *ngIf="show" class="loader-container">
    <div class="backdrop"></div>

    <div id="loader-wrapper">
        <div class="flex-box-spinner">
            <div id="loader"> </div>
            <div class="loader-section section-left"></div>
            <div class="loader-section section-right"></div>
            <img [src]="'images/loader.png' | environment" class="logoimg" alt="loader.png" />
        </div>
    </div>
</ng-container>